import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_USER}/merchant/main`;

export async function getMainSchool(params: any) {
  return client.post({
    url: `${url}/me`,
    form: {
      ...params
    }
  });
}
